import React from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Spinner } from '@blueprintjs/core'
import backgroundImage from '../../../assets/images/bg1.png'

function LoadingCover ({ showSpinner, spinnerSize, text, zIndex, notAbsolute, action }) {
  return (
    <div css={css`position: ${notAbsolute ? 'relative' : 'absolute'}; width: 100%; height: 100%; z-index: ${zIndex || 999}; text-align: center;
background-image: url(${backgroundImage}); background-size: cover; background-repeat: no-repeat; background-color: var(--primary2);
`}>
      <div css={css`position: absolute; top: 45%; left: 50%; transform: translate(-50%, -50%);`}>{showSpinner && <Spinner size={spinnerSize} intent={'primary'} />}
        <br />
        <div
          css={css`color: var(--gray6);`}>{text}</div>
        <br />
        {action}
      </div>
    </div>
  )
}

export default LoadingCover
